module.exports = __webpack_public_path__ + "img/20.a0f8cab2.jpg";